export const blockpotConfigManagerAbi = [
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '_votingPowerProvider',
                'type': 'address'
            },
            {
                'internalType': 'uint256',
                'name': 'minimumEntryAmount',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'nonpayable',
        'type': 'constructor'
    },
    {
        'inputs': [],
        'name': 'PROPOSAL_LENGTH',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'PROPOSAL_START_OFFSET',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'enum BlockpotConfigManager.ParameterType',
                'name': '',
                'type': 'uint8'
            }
        ],
        'name': 'activeProposalParameterTypes',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'game',
                'type': 'address'
            },
            {
                'components': [
                    {
                        'internalType': 'uint48',
                        'name': 'timeBetweenRounds',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chanceIncrementAmount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chanceMultiplierAmount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chanceInitialAmount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'maxProbability',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'rewardsPercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'operationsPercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'nextPotPercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'parentGamePercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'hasParent',
                        'type': 'bool'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'ignoreOdds',
                        'type': 'bool'
                    },
                    {
                        'internalType': 'uint24[]',
                        'name': 'numAllocs',
                        'type': 'uint24[]'
                    }
                ],
                'internalType': 'struct GameConfig',
                'name': 'config',
                'type': 'tuple'
            }
        ],
        'name': 'addGame',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address'
            }
        ],
        'name': 'addOwner',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'proposalIndex',
                'type': 'uint32'
            }
        ],
        'name': 'canCloseProposal',
        'outputs': [
            {
                'internalType': 'bool',
                'name': 'canClose',
                'type': 'bool'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'canCreateProposal',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'proposalIndex',
                'type': 'uint32'
            }
        ],
        'name': 'closeProposal',
        'outputs': [
            {
                'internalType': 'bool',
                'name': 'didClose',
                'type': 'bool'
            }
        ],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'enum BlockpotConfigManager.ParameterType',
                'name': 'parameterType',
                'type': 'uint8'
            },
            {
                'internalType': 'uint256',
                'name': 'proposedValue',
                'type': 'uint256'
            },
            {
                'internalType': 'string',
                'name': 'resRef',
                'type': 'string'
            },
            {
                'internalType': 'address',
                'name': 'game',
                'type': 'address'
            }
        ],
        'name': 'createProposal',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'createProposalStakeRequirement',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'getNextBlockpotConfig',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'minimumEntryAmount',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'bptDiscount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'referralDiscount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'minStakeTime',
                        'type': 'uint48'
                    }
                ],
                'internalType': 'struct BlockpotConfig',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'game',
                'type': 'address'
            }
        ],
        'name': 'getNextGameConfig',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'uint48',
                        'name': 'timeBetweenRounds',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chanceIncrementAmount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chanceMultiplierAmount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'chanceInitialAmount',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'maxProbability',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'rewardsPercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'operationsPercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'nextPotPercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'uint24',
                        'name': 'parentGamePercentage',
                        'type': 'uint24'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'hasParent',
                        'type': 'bool'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'ignoreOdds',
                        'type': 'bool'
                    },
                    {
                        'internalType': 'uint24[]',
                        'name': 'numAllocs',
                        'type': 'uint24[]'
                    }
                ],
                'internalType': 'struct GameConfig',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'proposalIndex',
                'type': 'uint32'
            }
        ],
        'name': 'getProposal',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'proposedValue',
                        'type': 'uint256'
                    },
                    {
                        'internalType': 'address',
                        'name': 'game',
                        'type': 'address'
                    },
                    {
                        'internalType': 'address',
                        'name': 'proposer',
                        'type': 'address'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'totalStaked',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'totalVotes',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'totalYaeVotes',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'voteStartTime',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'voteEndTime',
                        'type': 'uint48'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'executed',
                        'type': 'bool'
                    },
                    {
                        'internalType': 'bool',
                        'name': 'closed',
                        'type': 'bool'
                    },
                    {
                        'internalType': 'enum BlockpotConfigManager.ParameterType',
                        'name': 'parameterType',
                        'type': 'uint8'
                    },
                    {
                        'internalType': 'string',
                        'name': 'resRef',
                        'type': 'string'
                    }
                ],
                'internalType': 'struct BlockpotConfigManager.Proposal',
                'name': '',
                'type': 'tuple'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'proposer',
                'type': 'address'
            }
        ],
        'name': 'hasProposalActive',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'proposalId',
                'type': 'uint32'
            }
        ],
        'name': 'isEligibleToVoteOnProposal',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'voter',
                'type': 'address'
            },
            {
                'internalType': 'uint32',
                'name': 'proposalId',
                'type': 'uint32'
            }
        ],
        'name': 'isEligibleToVoteOnProposalForAddress',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address'
            }
        ],
        'name': 'isOwner',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'name': 'proposals',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'proposedValue',
                'type': 'uint256'
            },
            {
                'internalType': 'address',
                'name': 'game',
                'type': 'address'
            },
            {
                'internalType': 'address',
                'name': 'proposer',
                'type': 'address'
            },
            {
                'internalType': 'uint48',
                'name': 'totalStaked',
                'type': 'uint48'
            },
            {
                'internalType': 'uint48',
                'name': 'totalVotes',
                'type': 'uint48'
            },
            {
                'internalType': 'uint48',
                'name': 'totalYaeVotes',
                'type': 'uint48'
            },
            {
                'internalType': 'uint48',
                'name': 'voteStartTime',
                'type': 'uint48'
            },
            {
                'internalType': 'uint48',
                'name': 'voteEndTime',
                'type': 'uint48'
            },
            {
                'internalType': 'bool',
                'name': 'executed',
                'type': 'bool'
            },
            {
                'internalType': 'bool',
                'name': 'closed',
                'type': 'bool'
            },
            {
                'internalType': 'enum BlockpotConfigManager.ParameterType',
                'name': 'parameterType',
                'type': 'uint8'
            },
            {
                'internalType': 'string',
                'name': 'resRef',
                'type': 'string'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'renounceOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'totalProposals',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address'
            }
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'proposalId',
                'type': 'uint32'
            },
            {
                'internalType': 'bool',
                'name': 'yae',
                'type': 'bool'
            }
        ],
        'name': 'vote',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'votingPower',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'voter',
                'type': 'address'
            }
        ],
        'name': 'votingPowerForAddress',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'inputs': [],
        'name': 'votingPowerProvider',
        'outputs': [
            {
                'internalType': 'contract IVotingPowerProvider',
                'name': '',
                'type': 'address'
            }
        ],
        'stateMutability': 'view',
        'type': 'function'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'account',
                'type': 'address'
            },
            {
                'indexed': false,
                'internalType': 'bool',
                'name': 'isOwner',
                'type': 'bool'
            }
        ],
        'name': 'OwnershipChange',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint32',
                'name': 'proposalIndex',
                'type': 'uint32'
            },
            {
                'indexed': false,
                'internalType': 'bool',
                'name': 'executed',
                'type': 'bool'
            }
        ],
        'name': 'ProposalClosed',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint32',
                'name': 'proposalIndex',
                'type': 'uint32'
            },
            {
                'indexed': false,
                'internalType': 'enum BlockpotConfigManager.ParameterType',
                'name': 'parameterType',
                'type': 'uint8'
            }
        ],
        'name': 'ProposalCreated',
        'type': 'event'
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint32',
                'name': 'proposalIndex',
                'type': 'uint32'
            },
            {
                'indexed': false,
                'internalType': 'bool',
                'name': 'yae',
                'type': 'bool'
            }
        ],
        'name': 'ProposalVote',
        'type': 'event'
    },
    {
        'inputs': [],
        'name': 'BptDiscountGreaterThanTenPercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'BptDiscountLessThanOnePercent',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'enum IndexOutOfBoundsType',
                'name': 't',
                'type': 'uint8'
            }
        ],
        'name': 'IndexOutOfBounds',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'proposalId',
                'type': 'uint32'
            },
            {
                'internalType': 'enum IneligibleToVoteOnProposalType',
                'name': 't',
                'type': 'uint8'
            }
        ],
        'name': 'IneligibleToVoteOnProposal',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'InsufficientStakeForProposal',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'uint8',
                'name': 'valueId',
                'type': 'uint8'
            }
        ],
        'name': 'InvalidParameterType',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'enum BlockpotConfigManager.ParameterType',
                'name': 't',
                'type': 'uint8'
            },
            {
                'internalType': 'uint256',
                'name': 'value',
                'type': 'uint256'
            }
        ],
        'name': 'InvalidProposalValue',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'MaxProbabilityGreaterThanOneHundredPercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'MaxProbabilityLessThanInitial',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'MaxProbabilityLessThanTenPercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'MinStakeTimeGreaterThanThirtyOneDays',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'MinimumEntryTooHigh',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'MinimumEntryTooLow',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'NextPotPercentageGreaterThanTwentyPercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'NextPotPercentageLessThanOnePercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'NotAnOwner',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'OperationsPercentageGreaterThanOnePercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'OperationsPercentageLessThanZeroPointOnePercent',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'enum BlockpotConfigManager.ParameterType',
                'name': 't',
                'type': 'uint8'
            }
        ],
        'name': 'ParameterTypeRequiresGameAddress',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ParentGamePercentageGreaterThanFifteenPercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ParentGamePercentageLessThanFivePercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ParentGamePercentageMustBeZeroWhenNoParent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'PotAllocationNotDescending',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'PotAllocationTotalNotEqualToOneHundredPercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'PotAllocationTotalNumbersGreaterThanTen',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'PotAllocationTotalNumbersLessThanOne',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ProbabilityIncrementGreaterThanTenPercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ProbabilityInitialGreaterThanTwentyFivePercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ProbabilityInitialLessThanZeroPointOnePercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ProbabilityMultiplierGreaterThanThree',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ProbabilityMultiplierLessThanOne',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'enum BlockpotConfigManager.ParameterType',
                'name': '',
                'type': 'uint8'
            }
        ],
        'name': 'ProposalAlreadyActive',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'proposalId',
                'type': 'uint32'
            }
        ],
        'name': 'ProposalIdOutOfBounds',
        'type': 'error'
    },
    {
        'inputs': [
            {
                'internalType': 'uint32',
                'name': 'proposalId',
                'type': 'uint32'
            }
        ],
        'name': 'ProposalOutsideVotingPeriod',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ReferralDiscountGreaterThanTenPercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ReferralDiscountLessThanOnePercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'RewardsPercentageGreaterThanFifteenPercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'RewardsPercentageLessThanTwoPointFivePercent',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'TimeBetweenRoundsGreaterThanSevenDays',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'TimeBetweenRoundsLessThanEightHours',
        'type': 'error'
    },
    {
        'inputs': [],
        'name': 'ZeroAddressOwner',
        'type': 'error'
    }
] as const